import { styled } from 'linaria/react';

export const Section = styled.section`
  width: 100%;

  @media (--only-largeDesktop) {
    margin-bottom: 80px;
  }

  @media (--from-tablet) and (--to-largeDesktop) {
    margin-bottom: 64px;
  }

  @media (--only-mobile) {
    margin-bottom: 40px;
  }
`;
